import {transformFeaturesToFilters} from "@/transformers/FeatureTransformer";
import {Filter} from "@/models/frontend/FeatureModels";
import {featureService} from "@/services/backend/FeatureService";
import { FilterDefaultPostalCode, FilterLimitDistance, FilterLimitPrice, FilterDefaultDistance } from "@/beepallet.consts";
import { ref } from "vue";
import { UserStorageService } from "../backend/UserService";

export const lastSearch = ref<Filter[]>([]);
export const lastNumFiltersApplied = ref<number>();

export async function fetchAndCombineFilters(): Promise<Filter[]> {
  // Static filters
  const staticFilters: Filter[] = [
    {
      id: 'pcode',
      type: 'text-search',
      label: 'Código postal:',
      placeholder: 'Selecciona',
      value: (UserStorageService.user.postalCode) ? UserStorageService.user.postalCode : FilterDefaultPostalCode,
      defaultValue: (UserStorageService.user.postalCode) ? UserStorageService.user.postalCode : FilterDefaultPostalCode,
      clearable: false,
    },
    {
      id: 'distance',
      type: 'slider',
      label: 'Distancia:',
      min: 0,
      max: FilterLimitDistance,
      unit: 'km',
      value: FilterDefaultDistance,
      placeholder: 'Selecciona',
      initialValue: FilterDefaultDistance,
      defaultValue: null,
      clearable: true,
    },
    {
      id: 'type',
      type: 'dropdown-multiselect',
      label: 'Tipo de anuncio:',
      placeholder: 'Selecciona',
      options: [
        { label: 'Venta', value: 'SALE' },
        { label: 'Compra', value: 'OFFER' },
        // { label: 'Alquiler', value: 3 },
        { label: 'Servicio', value: 'SERVICE' },
      ],
      value: [],
      defaultValue: [],
      clearable: true,
    }
  ];


  // Fetch dynamic filters from the API
  const features = await featureService.searchFeatures({
    sort: { sortBy: 'name', sortOrder: 'ASC' },
    pagination: { limit: 25, offset: 0 },
  });


  const dynamicFilters = transformFeaturesToFilters(features);

  const additionalFilters: Filter[] = [
    {
      id: 'price',
      type: 'slider',
      label: 'Precio/ud:',
      min: 0,
      max: FilterLimitPrice,
      unit: '€',
      value: null,
      placeholder: 'Selecciona',
      initialValue: 0,
      defaultValue: null,
      clearable: true
    },
    {
      id: 'quantity',
      type: 'numeric-input',
      label: 'Cantidad:',
      placeholder: 'Selecciona',
      value: null,
      defaultValue: null,
      clearable: true
    },
    {
      id: 'shipmentMethod',
      type: 'dropdown-multiselect',
      label: 'Método de envío:',
      placeholder: 'Selecciona',
      options: [
        { label: 'Envío', value: 1 },
        { label: 'Recogida', value: 2 }
      ],
      value: [],
      defaultValue: [],
      clearable: true
    },
    {
      id: 'availableDate',
      type: 'date-selector',
      label: 'Disponibilidad:',
      minDate: '2024-11-18',
      value: '',
      placeholder: 'Selecciona',
      defaultValue: '',
      clearable: true
    },
  ];

  // Combine static and dynamic filters
  return [...staticFilters, ...dynamicFilters, ...additionalFilters];
}




